import React from 'react';
import classnames from 'classnames';
import useIsFCM from '../../hooks/useIsFCM';
import useIsCBD from '../../hooks/useIsCBD';

const IconsBG = () => {
  const isFcm = useIsFCM();
  const isCbd = useIsCBD();
  const showFcmIcon = Boolean(isFcm) || Boolean(isCbd);
  return (
    <section
      className={classnames({
        'erisx-icons-bg': true,
        'fcm-icon': showFcmIcon,
      })}
    >
      <aside className="erisx-icon-bg left" />
      <aside className="erisx-icon-bg spacer" />
      <aside className="erisx-icon-bg right" />
    </section>
  );
};

export default IconsBG;
